import { ADD_IP_RESULTS } from './interestProfiler'

import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const SELECT_BUDGET = 'BUDGET_SELECT_BUDGET'
export const LOAD_LOCATIONS = 'BUDGET_LOAD_LOCATIONS'
export const SELECT_STATE = 'BUDGET_SELECT_STATE'
export const UPDATE_ACTIVE_ROUND = 'BUDGET_UPDATE_ACTIVE_ROUND'
export const LIST_BUDGETS = 'BUDGET_LIST_BUDGETS'
export const SELECT_BUDGET_FOR_EDIT = 'SELECT_BUDGET_FOR_EDIT'
export const BUDGET_EDIT_RECORD = 'BUDGET_EDIT_RECORD'
export const UPDATE_SELECTED_RECORD = 'BUDGET_UPDATE_SELECTED_RECORD'
export const UPDATE_EDITING_NAME = 'BUDGET_UPDATE_EDITING_NAME'
export const LOAD_WAGE_FOR_REVERSE = 'BUDGET_LOAD_WAGE_FOR_REVERSE'
export const BUDGET_SAVE_PORTFOLIO = 'BUDGET_SAVE_PORTFOLIO'
export const BUDGET_SAVE_PORTFOLIO_DISMISS = 'BUDGET_SAVE_PORTFOLIO_DISMISS'
export const BUDGET_SAVE_CAREERHUB = 'BUDGET_SAVE_CAREERHUB'
export const BUDGET_SAVE_RESPONSE = 'BUDGET_SAVE_RESPONSE'
export const BUDGET_APPEND_REPLACE_RESPONSE = 'BUDGET_APPEND_REPLACE_RESPONSE'
export const BUDGET_RESULTS = 'BUDGET_RESULTS'
export const ADD_BUDGET_RESULTS = 'ADD_BUDGET_RESULTS'

export const startBudget = isReverse => dispatch => {
  return dispatch(h2Api.post('/budget/new', { isReverse })({ type: SELECT_BUDGET }))
}

export const selectForEdit = budget => dispatch => {
  return dispatch({ type: SELECT_BUDGET_FOR_EDIT, budget })
}

export const saveEdit = record => dispatch => {
  return dispatch(
    h2Api.put(`/budget/${record.id}`, record)({ type: BUDGET_EDIT_RECORD })
  ).then(r => dispatch({ type: UPDATE_SELECTED_RECORD, record: r }))
}

export const updateTitleText = name => dispatch => {
  return dispatch({ type: UPDATE_EDITING_NAME, name })
}

export const loadBudget = (id, forceReload = false, markSummarized = false) => (
  dispatch,
  getState
) => {
  const b = getState().assessments.budget.main.result

  if (forceReload || !b || (!b.summarized && markSummarized)) {
    if (markSummarized) {
      return dispatch(
        h2Api.post(`/budget${id != null ? `/${id}` : ''}/markSummarized`)({
          type: SELECT_BUDGET
        })
      )
    }

    return dispatch(
      h2Api.get(`/budget${id != null ? `/${id}` : ''}`)({ type: SELECT_BUDGET })
    )
  }

  return Promise.resolve(getState().assessments.budget.main.result)
}

export const setBudgetToPrimary = budgetId => (dispatch, getState) => {
  return dispatch(h2Api.put(`/budget/${budgetId}/makeDefault`)({ type: SELECT_BUDGET }))
}

export const deleteBudget = id => dispatch => {
  return dispatch(h2Api.doDelete(`/budget/${id}`)({ type: LIST_BUDGETS }))
}

export const listBudgets = () => (dispatch, getState) => {
  return dispatch(h2Api.get('/budget/list')({ type: LIST_BUDGETS }))
}

export const loadCountyData = state => dispatch => {
  const d = state !== 'US' ? { state } : {}

  return dispatch(h2Api.post('/budget/locations', { ...d })({ type: LOAD_LOCATIONS }))
}

export const setActiveRound = roundId => dispatch => {
  return dispatch({ type: UPDATE_ACTIVE_ROUND, roundId })
}

export const updateBudgetLocationByCounty = county => (dispatch, getState) => {
  return dispatch(
    h2Api.post('/budget/respond/location', {
      countyId: county
    })({ type: SELECT_BUDGET })
  )
}

export const updateReverseBudgetSalary = amount => (dispatch, getState) => {
  return dispatch(
    h2Api.post('/budget/respond/salary', {
      salary: amount
    })({ type: SELECT_BUDGET })
  )
}

/** The onetSoc param is optional, without it we'll retrieve average wage*/
export const getReverseWages = onetSoc => dispatch => {
  return dispatch(
    h2Api.post('/budget/wages', {
      onetSoc
    })({ type: LOAD_WAGE_FOR_REVERSE })
  )
}

export const updateBudgetLocationByZip = zipCode => dispatch => {
  return dispatch(
    h2Api.post('/budget/respond/location/zipcode', {
      zipCode
    })({ type: SELECT_BUDGET })
  )
}

export const updateBudgetResponse = resp => dispatch => {
  console.log(resp)

  return dispatch(
    h2Api.put(`/budget/respond/round/${resp.round}`, {
      total: resp.total,
      choices: resp.choices
    })({ type: SELECT_BUDGET })
  ) /*.then((r) => {
        dispatch({ type: BUDGET_APPEND_REPLACE_RESPONSE, response: r})
    }) */
}

export const addCustomOption = (roundId, option) => dispatch => {
  return dispatch(
    h2Api.post(
      `/budget/custom/${roundId}`,
      option
    )({
      type: SELECT_BUDGET
    })
  )
}

export const findBudgetChoicesInRound = (roundId, responses) => {
  // console.log(responses, roundId)
  const bAmt = responses.find(r => r.round == roundId)

  return bAmt ? bAmt.choices : []
}

export const saveBudgetToHub = budgetId => dispatch => {
  return dispatch(
    h2Api.post(`/budget/${budgetId}/save`)({ type: BUDGET_SAVE_CAREERHUB })
  ).then(() => dispatch({ type: BUDGET_SAVE_PORTFOLIO, budgetId }))
}

export const closeBudgetHubConfirm = () => dispatch => {
  dispatch({ type: BUDGET_SAVE_PORTFOLIO_DISMISS })
}

export const findBudgetAmountInRound = (roundId, responses) => {
  //  console.log(responses, roundId)
  const bAmt = responses?.find(r => r.round == roundId)

  return formatCurrency((bAmt && bAmt.total) || 0)
}

export const formatCurrency = amt => {
  if (!amt && amt !== 0) {
    return ''
  }

  return amt.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}

export const loadBudgetResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/budget/results`, { filters })({ type: BUDGET_RESULTS })
  ).then(v => {
    console.log(v)
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentBudgetResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/budget/results`, updatedJson)({ type: ADD_BUDGET_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
